import { Diagnosis } from 'interfaces';
import { http, HttpResponse } from 'msw';

export const mockDiagnoses: Diagnosis[] = [
  {
    id: '22222222-2222-4222-8222-222222222221',
    icd9: '123',
    description: 'Other specified diagnosis',
  },
  {
    id: '22222222-2222-4222-8222-222222222222',
    icd9: '250',
    description: 'Diabetes mellitus',
  },
  {
    id: '22222222-2222-4222-8222-222222222223',
    icd9: '250.00',
    description: 'Diabetes mellitus without complication',
  },
  {
    id: '22222222-2222-4222-8222-222222222224',
    icd9: '401',
    description: 'Essential hypertension',
  },
];

export const mockDiagnosisHandlers = [
  http.get('*/resource/diagnosis/search', ({ request }) => {
    const searchValue = new URL(request.url).searchParams
      .get('searchValue')
      ?.trim()
      .toLowerCase();

    const diagnoses = searchValue
      ? mockDiagnoses.filter(
          ({ icd9, description }) =>
            icd9.toLowerCase().includes(searchValue) ||
            description.toLowerCase().includes(searchValue)
        )
      : [];

    return HttpResponse.json(diagnoses);
  }),
];
